/* global Swiper */
// *******************************************************************************
// 1.0 - Partners slider
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.partnersSliderElements = document.querySelectorAll('[data-slider="partners-slider"]');

  window.partnersSliderOptions = {
    slidesPerView: 2,
    spaceBetween: 16,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    allowTouchMove: true,
    breakpoints: {
      580: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1023: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
      1199: {
        slidesPerView: 6,
        spaceBetween: 28,
      },
    },
  };

  partnersSliderElements.forEach((el) => {
    const parent = el.closest('.partners');
    const arrowRight = parent.querySelector('.swiper-button-next');
    const arrowLeft = parent.querySelector('.swiper-button-prev');

    partnersSliderOptions.navigation.nextEl = arrowRight;
    partnersSliderOptions.navigation.prevEl = arrowLeft;

    // eslint-disable-next-line no-new
    new Swiper(el, partnersSliderOptions);
  });
});
